/* eslint-disable react/jsx-no-useless-fragment */
import * as statisticsActions from "store/actions/statisticsActions";
import { useDispatch, useSelector } from "react-redux";
import Popover from "../../../../components/Popover";
import { statistics } from "store/actions/types";
import { Button, Form } from "components";
import { useState } from "react";
import "./statisticsButton.css";
import i18n from "i18next";

const StatisticsButton = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [motivation, setMotivation] = useState();
  const [institution, setInstitution] = useState("");
  const [motivationDetail, setMotivationDetail] = useState("");
  const { loading } = useSelector((state) => state.statistics);

  const onDownload = () => {
    const emailIsValid = email.includes("@");
    const institutionIsValid = institution.trim().length >= 2;
    const selectedMotivation = motivation?.value;
    const validMotivation =
      selectedMotivation &&
      (selectedMotivation !== "Outro" ||
        (selectedMotivation === "Outro" &&
          motivationDetail.trim().length > 10));

    if (!emailIsValid) {
      dispatch({
        type: statistics.DOWNLOAD_FAIL,
        payload: i18n.t("invalidEmailMessage"),
      });
      return false;
    }

    if (!institutionIsValid) {
      dispatch({
        type: statistics.DOWNLOAD_FAIL,
        payload: i18n.t("invalidInstitutionMessage"),
      });
      return false;
    }

    if (!validMotivation) {
      dispatch({
        type: statistics.DOWNLOAD_FAIL,
        payload: i18n.t("invalidMotivationMessage"),
      });
      return false;
    }

    const payload = {
      email,
      institution,
      motivation:
        selectedMotivation === "Outro" ? motivationDetail : selectedMotivation,
    };

    dispatch(statisticsActions.download(payload));

    return true;
  };

  const onSendData = (sendData) => {
    const gotData = onDownload(sendData);

    if (gotData) {
      setShowModal(false);
      setInstitution("");
      setMotivation("");
      setEmail("");
    }
  };

  const onOpenDownload = () => {
    setShowModal(!showModal);
  };

  const options = [
    { label: i18n.t("researchMotivation"), value: "Pesquisa acadêmica" },
    { label: i18n.t("policyMotivation"), value: "Políticas Pública" },
    {
      label: i18n.t("monitoringMotivation"),
      value: "Monitoramento socioambiental",
    },
    { label: i18n.t("landUseMotivation"), value: "Gestão territorial" },
    {
      label: i18n.t("restorationMotivation"),
      value: "Projetos de restauração",
    },
    { label: i18n.t("educationMotivation"), value: "Educação ou capacitação" },
    { label: i18n.t("communicationMotivation"), value: "Comunicação" },
    {
      label: i18n.t("privateSectorMotivation"),
      value: "Projetos no setor privado",
    },
    {
      label: i18n.t("financialSectorMotivation"),
      value: "Análises no setor financeiro",
    },
    { label: i18n.t("otherMotivation"), value: "Outro" },
  ];

  return (
    <>
      <Button
        loading={loading}
        multipleState
        variant="outline-primary"
        size="md"
        onClick={onOpenDownload}
        style={{ margin: `0px 0 0 10px` }}
      >
        <span className="spinner tcf-d-inline-block">
          <span className="bounce1" />
          <span className="bounce2" />
          <span className="bounce3" />
        </span>
        <svg
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.5 10V12.6667C14.5 13.0203 14.3595 13.3594 14.1095 13.6095C13.8594 13.8595 13.5203 14 13.1667 14H3.83333C3.47971 14 3.14057 13.8595 2.89052 13.6095C2.64048 13.3594 2.5 13.0203 2.5 12.6667V10"
            stroke="#78C753"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.1665 6.66669L8.49984 10L11.8332 6.66669"
            stroke="#78C753"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.5 10V2"
            stroke="#78C753"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Button>
      <Popover
        size="lg"
        showModal={showModal}
        setShowModal={setShowModal}
        className="popover-wrapper"
        content={
          <form
            onSubmit={(e) => e.preventDefault()}
            className="popover-content-form"
          >
            <h2 className="tcf-subtitle">{i18n.t("infoText")}</h2>
            <p className="tcf-paragraph">{i18n.t("sendInfoText")}</p>
            <Form.FormGroup>
              <Form.Label htmlFor="email">
                {i18n.t("yourContactMail")}
              </Form.Label>
              <Form.Control
                type="email"
                name="email"
                id="email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
              />

              <Form.Label htmlFor="institution">
                {i18n.t("yourInstitution")}
              </Form.Label>
              <Form.Control
                type="institution"
                name="institution"
                id="institution"
                onChange={(e) => setInstitution(e.target.value)}
                value={institution}
                required
                valid="true"
              />

              <Form.Label htmlFor="institution">
                {i18n.t("yourObjective")}
              </Form.Label>

              <Form.Select
                options={options}
                onChange={(opt) => setMotivation(opt)}
                defaultValue={motivation}
                type="motivation"
                name="motivation"
                id="motivation"
                className="w-full"
              />

              {motivation?.value === "Outro" && (
                <Form.Control
                  type="text"
                  name="motivationDetail"
                  id="motivationDetail"
                  onChange={(e) => setMotivationDetail(e.target.value)}
                  placeHolder={i18n.t("yourObjective")}
                  value={motivationDetail}
                  required
                  valid="true"
                />
              )}

              <div className="button-submit-wrapper">
                <Button
                  type="submit"
                  variant="primary"
                  size="md"
                  style={{ width: "100%", height: "65px", margin: "10px 0px" }}
                  onClick={() => onSendData(true)}
                >
                  {i18n.t("sendInfo")}
                </Button>
              </div>

              <span className="terms-scrollbox">{i18n.t("dataTermText")}</span>
            </Form.FormGroup>
          </form>
        }
      />
    </>
  );
};

export default StatisticsButton;
